import React, { useEffect, useState } from "react"
import { Card, CardBody, Button, Table, Row, Col } from "reactstrap"
import { connect } from "react-redux"
import { useParams, Redirect } from "react-router-dom"
import { formatAddress } from "../utils"
import BreadCrumb from "../Components/BreadCrumb"

const TradingDetail = (props) => {
    const { id } = useParams()
    const { allTokens } = props
    const [selectedToken, setSelectedToken] = useState({})
    const [loading, isLoading] = useState(true)

    useEffect(() => {
        for (const token of allTokens) {
            if (id === token.token_id) {
                setSelectedToken(token)
                isLoading(false)
                break
            }
        }
    }, [id, allTokens])

    if (loading) {
        return <></>
    }

    if (!selectedToken.details) {
        return <Redirect to="/profile" />
    }

    return (
        <React.Fragment>
            <div className="content trading-detail-page">
                {/* <BreadCrumb current={`NFT ${id}`} /> */}
                <BreadCrumb items={["Trading", `NFT ${id}`]} links={["trading"]} />
                <Card>
                    <CardBody className="p-0">
                        <div className="trading-detail-page__content">
                            <div className="card-item">
                                <Row className="m-0">
                                    <Col xl={4} sm={5} className="plan-single-img">
                                        <img src={selectedToken.details.uri} alt={"card"} />
                                    </Col>
                                    <Col xl={4} sm={7} className="plan-single-content d-flex flex-wrap align-items-center">
                                        <div>
                                            <h2>{selectedToken.details.name}</h2>
                                            <p>{selectedToken.details.description}</p>
                                        </div>
                                    </Col>
                                    <Col xl={3} md={12} className="d-flex flex-wrap align-items-end">
                                        <div className="card-item plan-single-buy p-4">
                                            <h3>Unique Collection</h3>
                                            <p>
                                                <strong>{formatAddress(selectedToken.wallet)}</strong>
                                                <span>{selectedToken.author}</span>
                                            </p>
                                            <div className="plan-btn-div">
                                                {selectedToken.price ? (
                                                    <Button color="primary">BUY NOW</Button>
                                                ) : (
                                                    <Button color="primary">SELL NOW</Button>
                                                )}
                                                {selectedToken.source.includes("polygon") && (
                                                    <a
                                                        className="card-menu-item"
                                                        href={`https://polygonscan.com/token/${selectedToken.wallet}`}
                                                        target={"_blank"}
                                                        rel="noreferrer"
                                                    >
                                                        View on PolygonScan
                                                    </a>
                                                )}
                                                {selectedToken.source.includes("avalanche") && (
                                                    <a
                                                        className="card-menu-item"
                                                        href={`https://cchain.explorer.avax.network/token/${selectedToken.wallet}`}
                                                        target={"_blank"}
                                                        rel="noreferrer"
                                                    >
                                                        View on AvalancheScan
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    {selectedToken.price && (
                                        <div className="plan-price">
                                            <label>Price</label>
                                            <h4>{selectedToken.price}</h4>
                                        </div>
                                    )}
                                </Row>
                            </div>
                        </div>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <div className="trading-detail-page__content">
                            <div className="history-table">
                                <h3 className="heading">History</h3>
                                <p className="description">This NFT History</p>
                                <Table className="align-middle mb-0 table-nowrap">
                                    <thead className="table-light">
                                        <tr>
                                            <th scope="col">Event</th>
                                            <th scope="col">From</th>
                                            <th scope="col">To</th>
                                            <th scope="col">Transaction</th>
                                            <th scope="col">Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    allTokens: state.commonReducer.allTokens
})

export default connect(mapStateToProps, null)(TradingDetail)
